<template>
  <vv-screen-wrapper>
    <div class="screen-container">
      <quiz-progress-bar />

      <template v-if="step === 'question'">
        <h1 class="question-title">{{ question }}</h1>

        <div class="colors">
          <vv-radio-color
            v-for="(radio, index) in choices"
            name="radios"
            :key="radio.value"
            :value="index"
            :color="radio.value"
            :label="radio.label"
            v-model.number="radioResponse"
          />
        </div>

        <div class="cta">
          <vv-button @click="goToResponse" :disabled="radioResponse === null">
            {{ $t('quiz.discoverResponse') }}
          </vv-button>
        </div>
      </template>

      <single-response v-if="step === 'response'" @next="nextQuestion" />
    </div>
  </vv-screen-wrapper>
</template>

<script>
import { VvButton, VvRadioColor, VvScreenWrapper } from '@/components/common'
import QuizProgressBar from './QuizProgressBar'
import SingleResponse from './responses/SingleResponse'
import { NEXT_QUESTION, RESPONSE } from '@/store/modules/quiz/types'

export default {
  name: 'SingleColor',
  components: { QuizProgressBar, SingleResponse, VvButton, VvRadioColor, VvScreenWrapper },
  props: {
    choices: Array,
    expectedResponse: Object,
    explanation: String,
    question: String
  },
  data() {
    return {
      radioResponse: null,
      step: 'question'
    }
  },
  methods: {
    goToResponse() {
      this.$store.dispatch(RESPONSE, { choice: this.radioResponse })
      this.step = 'response'
    },
    nextQuestion() {
      this.$store.dispatch(NEXT_QUESTION)
      this.reset()
    },
    // we reset the component because if the same type of question comes twice in a row
    // the component won't change and we'll stay on the response
    reset() {
      this.step = 'question'
      this.radioResponse = null
    }
  }
}
</script>

<style lang="scss" scoped>
.colors {
  text-align: center;
}
</style>
